import React from "react";
import cn from "classnames";
import { getEnv } from "shared/utils";
import Modal from "react-modal";
import Icon from "backpack-ui/dist/components/icon";
import Overlay from "shared/components/Overlay";
import Button from "../../../Button";
import Input from "../../Input";
import Results from "../../Results";
import styles from "./styles.css";

class InputModal extends React.Component {
  static defaultProps = {
    searchResults: [],
    searchTerm: "",
  };

  constructor(props) {
    super(props);

    this.state = {
      isVisible: false,
      offsetTop: 0,
    };
  }

  componentDidMount() {
    this.headerNode = null;

    if (typeof document !== "undefined") {
      this.headerNode = document.getElementById("global-header");
    }

    if (this.headerNode) {
      Modal.setAppElement(this.headerNode);
    }
  }

  getOffsetTop = () => {
    let offsetTop = 0;

    if (this.headerNode) {
      offsetTop = this.headerNode.getBoundingClientRect().top;
    }

    return offsetTop;
  };

  show = () => {
    this.setState({
      isVisible: true,
      offsetTop: this.getOffsetTop(),
    });
  };

  hide = () => {
    const { onRequestClose } = this.props;

    this.setState({ isVisible: false }, onRequestClose);
  };

  render() {
    const {
      isOpen,
      searchResults,
      searchTerm,
      onChange,
      onResultClick,
    } = this.props;
    const { isVisible, offsetTop } = this.state;
    const inputId = "search-input-mobile";

    return (
      <Modal
        isOpen={isOpen}
        overlayClassName={styles.modalOverlay}
        style={{ overlay: { top: `${offsetTop}px` } }}
        className={cn({
          [styles.wrapper]: true,
          [styles.isVisible]: isVisible,
        })}
        shouldCloseOnOverlayClick={false}
        onRequestClose={this.hide}
        onAfterOpen={this.show}
        closeTimeoutMS={200}
      >
        <Overlay onClick={this.hide} style={{ top: `${offsetTop}px` }} />

        <div className={styles.search}>
          <form action={getEnv("SEARCH_URL")} className={styles.container}>
            <Button element="label" className={styles.button} htmlFor={inputId}>
              <Icon.Search label="Search" />
            </Button>

            <Input
              ref={this.inputRef}
              className={styles.input}
              id={inputId}
              name="q"
              autoFocus
              onChange={onChange}
              value={searchTerm}
            />

            <Button className={styles.button} type="button" onClick={this.hide}>
              <Icon.Close label="Close search" />
            </Button>
          </form>

          {searchResults.length > 0 && (
            <Results
              className={styles.results}
              searchResults={searchResults}
              searchTerm={searchTerm}
              onClick={onResultClick}
            />
          )}
        </div>
      </Modal>
    );
  }
}

export default InputModal;
